import { useQuery } from '@tanstack/react-query'
import Consultation from '~models/consultation'
import ConsultationRepository from '~repositories/impl/consultation-repository'
import { APP_QUERY_KEYS } from './query-keys'

const useRelatedConsultations = (id: string | number) => {
  return useQuery<Consultation.Level1[], Error>({
    queryKey: APP_QUERY_KEYS.relatedConsultations(id),
    queryFn: () => ConsultationRepository.getRelatedConsultations(id),
    retry: 3,
  })
}

export default useRelatedConsultations
